<template>
  <nav v-if="items.length" class="event-nav" aria-label="Event sections">
    <v-container class="event-nav-inner">
      <a
        v-for="item in items"
        :key="item.id"
        :href="`#${item.id}`"
        :class="{ active: activeSection === item.id }"
        :aria-current="activeSection === item.id ? 'location' : null"
        @click.prevent="scrollToSection(item.id)"
      >
        {{ item.label }}
        <v-icon x-small>mdi-chevron-down</v-icon>
      </a>
    </v-container>
  </nav>
</template>

<script>
export default {
  name: 'EventSectionNav',
  props: { items: { type: Array, default: () => [] } },
  data: () => ({ activeSection: '' }),
  mounted() {
    this.syncActiveSection();
    window.addEventListener('hashchange', this.syncActiveSection);
  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.syncActiveSection);
  },
  methods: {
    syncActiveSection() {
      const sectionId = window.location.hash.slice(1);
      this.activeSection = this.items.some((item) => item.id === sectionId)
        ? sectionId
        : this.items[0]?.id || '';
    },
    scrollToSection(sectionId) {
      const target = document.getElementById(sectionId);

      if (!target) return;

      window.history.replaceState(null, '', `#${sectionId}`);
      this.activeSection = sectionId;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
  },
};
</script>

<style scoped>
.event-nav { backdrop-filter: blur(14px); background: rgba(5, 5, 5, 0.92); border-bottom: 1px solid #292929; border-top: 1px solid #292929; overflow-x: auto; position: sticky; top: 0; z-index: 8; }
.event-nav-inner { display: flex; gap: 8px; min-width: max-content; padding-bottom: 10px; padding-top: 10px; }
.event-nav a { align-items: center; background: #111; border: 1px solid #363636; border-radius: 999px; color: #d5d5d5; cursor: pointer; display: inline-flex; font-family: "Oswald", sans-serif; font-size: 0.8rem; font-weight: 800; gap: 4px; padding: 8px 11px; text-decoration: none; text-transform: uppercase; transition: background 150ms ease, border-color 150ms ease, color 150ms ease, transform 150ms ease; }
.event-nav a .v-icon { color: #777; transition: color 150ms ease, transform 150ms ease; }
.event-nav a:hover, .event-nav a:focus-visible { background: #211a10; border-color: #f0b13c; color: #fff; outline: none; transform: translateY(-1px); }
.event-nav a:hover .v-icon, .event-nav a:focus-visible .v-icon { color: #f0b13c; transform: translateY(1px); }
.event-nav a.active { background: #e23232; border-color: #e23232; color: #fff; }
.event-nav a.active .v-icon { color: #fff; }
</style>
